<div class="cart-item">

  <div class="image-wrapper">

    <img src="{{certificate.photo}}" class="image"
           (click)="openCertificateInfo()">
  </div>


  <div class="product-info">
    <div>
      <div class="product-name">Подарочный сертификат на {{certificate.amount  | number : '1.2-2' | currency: "EUR"}}</div>
    </div>



    <div class="count-block">

      <div class="buttons-block">
        <button class="decrease" [disabled]="count < 2" (click)="decreaseCount()">-</button>

        <input type="number" class="count-area"
               [ngModel]="count"
               [disabled]=true
               (ngModelChange)="changeCount($event)">

        <button class="increase"
                (click)="increaseCount()">+
        </button>

      </div>

    </div>


  </div>
  <div class="right-panel">
    <div class="cost-info">

      {{ (certificate.amount  * count)  | number : '1.2-2' | currency: "EUR"}}
    </div>
    <button class="menu-button-cart" (click)="deleteAll()">
      <span class="icon-trash_">
        <img src="../../../../assets/icons/trash.svg" class="icon-menu">
      </span>
    </button>
  </div>
</div>

<ng-template #dialog class="delete-dialog">
  <h2 mat-dialog-title>Удалить товар из корзины?</h2>
  <div mat-dialog-actions>
    <button class="main-button  cancel" mat-button [mat-dialog-close]="true">Да</button>
    <button class="main-button" mat-button mat-dialog-close [mat-dialog-close]="false">Нет</button>
  </div>
</ng-template>

